import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { OrganizationStatusType } from '@/bundle/_Opco/types/types';

export type CreateOrganizationPayloadType = {
  name: string;
};

type CreateOrganizationResponseType = {
  id: string;
  name: string;
  is_kyc_allowed: boolean;
  status: OrganizationStatusType;
};

export const createOrganizationApi = async (
  data: CreateOrganizationPayloadType
): Promise<ApiResponseType<CreateOrganizationResponseType>> => {
  const uri = '/organization/';

  return authApiService.POST(uri, data);
};
